(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 4789:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(5166);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/formik@2.2.9_react@17.0.2/node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(431);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.1.0_61390be992b634a688f7c2555547b55b/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(6351);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(5423);
// EXTERNAL MODULE: ./src/ui/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(3312);
// EXTERNAL MODULE: ./src/ui/components/LocationInfo/index.tsx + 1 modules
var LocationInfo = __webpack_require__(5119);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/styles/register/index.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n display: flex;\n flex-direction: column;\n align-items: center;\n padding: 3vh 2vw 8vh;\n border-top: 1px solid #ddd;\n\n h1 {\n  color: #f70;\n  font-variant: small-caps;\n  font-weight: 500;\n  font-stretch: 110%;\n  font-size: 1.4em;\n }\n\n form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 56%;\n\n  fieldset {\n   display: grid;\n   grid-template-columns: 1fr 1fr;\n   grid-gap: 10%;\n   margin-top: 1vw;\n   width: 100%;\n\n   div {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n\n    label {\n     color: #777;\n     font-style: italic;\n     margin-bottom: 0.3vw;\n    }\n\n    input,\n    select {\n     padding: 0 0.5vw;\n     border: 1px solid rgba(0, 0, 0, 0.4);\n     border-radius: 5px;\n     font-size: 1rem;\n     height: 2.3vw;\n    }\n\n    p {\n     color: #fff;\n     background: #f00;\n     box-shadow: 0 0 8px #000;\n     border-radius: 10px;\n     position: absolute;\n     max-width: 80%;\n     right: -5%;\n     bottom: 50%;\n     padding: 0 6px;\n    }\n\n    p.long-error {\n     max-width: 60%;\n    }\n   }\n\n   &:last-of-type {\n    display: block;\n\n    div {\n     display: inline-block;\n     margin-bottom: 1vw;\n\n     input {\n      height: auto;\n      margin-right: 0.5vw;\n     }\n\n     label {\n      color: #000;\n      font-style: normal;\n     }\n\n     p {\n      all: unset;\n      display: block;\n      margin-bottom: 0.5vw;\n      font-weight: 700;\n      color: #f00;\n     }\n    }\n   }\n  }\n\n  a {\n   align-self: flex-start;\n   font-size: 0.94em;\n  }\n\n  button {\n   margin: 1vw 0;\n   max-width: 50%;\n  }\n\n  button:disabled {\n   background-color: #0007;\n   pointer-events: none;\n  }\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Styling = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a3d2573-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/pages/register/index.tsx








var title = 'Cadastro';
var Register = function() {
    var handleSubmit = function(values) {
        alert(values);
    };
    var universities = [
        'UFCG',
        'UFMG',
        'UFPA',
        'UFPB',
        'UFPE',
        'UFPI',
        'UFPR'
    ];
    var formValidation = es/* object */.Ry().shape({
        name: es/* string */.Z_().required('Por favor, insira seu nome.'),
        surname: es/* string */.Z_().required('Por favor, insira seu sobrenome.'),
        email: es/* string */.Z_().email('O e-mail inserido \xe9 inv\xe1lido.').required('Por favor, insira um e-mail.'),
        university: es/* string */.Z_().required('Por favor, selecione uma universidade.'),
        password: es/* string */.Z_().required('Por favor, insira sua senha.'),
        repeat_password: es/* string */.Z_().oneOf([
            es/* ref */.iH('password')
        ], 'As senhas n\xe3o s\xe3o iguais.').required('Por favor, repita sua senha.'),
        privacy_agreement: es/* boolean */.O7().oneOf([
            true
        ], 'Voc\xea precisa concordar com os termos de privacidade.'),
        notification_agreement: es/* boolean */.O7()
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                noindex: true,
                nofollow: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationInfo/* default */.Z, {
                children: "Cadastro"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styling, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "Cadastro"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        initialValues: {
                            name: '',
                            surname: '',
                            email: '',
                            university: '',
                            password: '',
                            repeat_password: '',
                            privacy_agreement: false,
                            notification_agreement: false
                        },
                        onSubmit: handleSubmit,
                        validationSchema: formValidation,
                        children: function(param) {
                            var isValid = param.isValid;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "name",
                                                        children: "Nome"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        id: "name",
                                                        name: "name"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                                        name: "name",
                                                        component: "p"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "surname",
                                                        children: "Sobrenome"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        id: "surname",
                                                        name: "surname"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                                        className: "long-error",
                                                        name: "surname",
                                                        component: "p"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "email",
                                                        children: "E-mail"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        id: "email",
                                                        name: "email",
                                                        type: "email",
                                                        placeholder: "exemplo@gmail.com"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                                        name: "email",
                                                        component: "p"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "university",
                                                        children: "Institui\xe7\xe3o/Afilia\xe7\xe3o"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Field */.gN, {
                                                        id: "university",
                                                        name: "university",
                                                        as: "select",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "",
                                                                hidden: true,
                                                                selected: true,
                                                                children: "Escolha uma..."
                                                            }),
                                                            universities.map(function(university) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                                    value: university.toLowerCase(),
                                                                    children: university
                                                                }, university);
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                                        className: "long-error",
                                                        name: "university",
                                                        component: "p"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "password",
                                                        children: "Senha"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        id: "password",
                                                        name: "password",
                                                        type: "password"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                                        name: "password",
                                                        component: "p"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "repeat_password",
                                                        children: "Repetir senha"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        id: "repeat_password",
                                                        name: "repeat_password",
                                                        type: "password"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                                        name: "repeat_password",
                                                        component: "p"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                                        name: "privacy_agreement",
                                                        component: "p"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        id: "privacy_agreement",
                                                        name: "privacy_agreement",
                                                        type: "checkbox"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        htmlFor: "privacy_agreement",
                                                        children: [
                                                            "Sim, eu concordo em ter meus dados coletados e armazenados de acordo com a",
                                                            ' ',
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                href: "/privacy",
                                                                children: "declara\xe7\xe3o de privacidade"
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        id: "notification_agreement",
                                                        name: "notification_agreement",
                                                        type: "checkbox"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "notification_agreement",
                                                        children: "Sim, eu gostaria de ser notificado de publica\xe7\xf5es e an\xfancios novos."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        disabled: !isValid,
                                        type: "submit",
                                        children: "Cadastrar"
                                    })
                                ]
                            });
                        }
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var register = (Register);


/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LocationInfo; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.0.10_react-dom@17.0.2+react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(1999);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n font-size: 0.9em;\n margin: 2vh 2vw;\n\n @media (max-width: 462px) {\n  margin: 2vh 4vw;\n }\n\n span:last-of-type {\n  color: #f70;\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba06a0ec-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/index.tsx




var LocationInfo = function(param) {
    var children = param.children;
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "/",
                children: "In\xedcio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: " / "
            }),
            pathname.match(/\/issues.+/) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/issues",
                    children: "Arquivos / "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var components_LocationInfo = (LocationInfo);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [742,522,888,179], function() { return __webpack_exec__(4789); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);